import api from 'api'
import { Campaign } from '../../../../../types/campaign'

export default class VastMultiplierService {
  static defaultMultiplier = 1
  static multiplierStep = 0.5

  static fetchMultiplierValue = (campaignId: string): Promise<number> => {
    return api.campaign
      .getCampaignVastRequestMultiplier(campaignId)
      .then(res => {
        if (!res.data || !res.data.campaignVastRequestMultipliers) {
          return VastMultiplierService.defaultMultiplier
        }

        return res.data.campaignVastRequestMultipliers.multiplier
      })
      .catch(() => VastMultiplierService.defaultMultiplier)
  }

  static update = (campaignId: Campaign['id'], newValue: number): Promise<void> => {
    const valueToUpdate = VastMultiplierService.getValidatedValue(newValue.toString())

    return api.campaign.updateCampaignVastRequestMultiplier(campaignId, valueToUpdate).then(res => {
      if (!res.data) {
        return
      }
    })
  }

  static getValidatedValue = (value: string): number => {
    const twoDecimalPlaces = parseFloat(value).toFixed(2)
    const parsedValue = parseFloat(twoDecimalPlaces)

    if (isNaN(parsedValue)) {
      return 1
    }

    if (parsedValue < 1) {
      return 1
    }

    if (parsedValue > 10) {
      return 10
    }

    return parsedValue
  }
}
